module.exports = __webpack_public_path__ + "static/iconjar2-8-546ef853e97102a0118c863cdd374b7a.mp4";